/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 * 
 * 
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *            佛祖保佑       永不宕机     永无BUG
 * 
 * @Author: 王新
 * @Date: 2021-04-28 10:22:03
 * @FilePath: \operation-screen\src\config\api.js
 * @Description: 声明的接口
 */

import config from './config'

export const selectKyyOrgDetail = config.baseUrl + "/system/wechat/kyyOrganizationPcController/selectKyyOrgDetail" // 社会组织画像详情

export const kyyProjectStatistics = config.baseUrl + "/teamword/wechat/kyyProject/kyyProjectStatistics" // 社会组织画像详情项目列表
export const kyyActivityStatistics = config.baseUrl + "/teamword/wechat/kyyProject/kyyActivityStatistics" // 社会组织画像详情活动列表

export const selectKyyProjectDetail = config.baseUrl + "/teamword/wechat/kyyProject/selectKyyProjectDetail" // 项目详情

export const selectSignUpOrgNotGenerate = config.baseUrl + "/teamword/wechat/kyyProject/selectSignUpOrgNotGenerate" // 未指定 
export const selectSignUpOrgGenerate = config.baseUrl + "/teamword/wechat/kyyProject/selectSignUpOrgGenerate" // 查询报名的组织信息  已指定

export const ServiceDetailsPath = config.baseUrl + "/teamword/wechat/twActivity/selectActiviceByIdOrg" // 服务详情